import React, { Suspense } from 'react';

const MapViewComponent = React.lazy(() => import('./MapContainerComponent'));

export const MapLazyComponent: React.FC<{
  isMapViewEnabled: boolean;
  onListViewClickHandler: (listViewClicked: boolean) => void;
  handleNextClick?: (isInitialLoadData: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isDrawerVisible?: any;
}> = ({ isMapViewEnabled, onListViewClickHandler, handleNextClick, isDrawerVisible }) => {
  return (
    <Suspense fallback={''}>
      <MapViewComponent
        isMapViewEnabled={isMapViewEnabled}
        onListViewClickHandler={onListViewClickHandler}
        handleNextClick={handleNextClick}
        isDrawerVisible={isDrawerVisible}
      />
    </Suspense>
  );
};
